import { sleep } from '@lmt/unicorn-shared/app/helpers/sleep';

/*
 * This function could be called wherever we want to unfocus the RichEditor
 * and prevent it from grabbing the focus back.
 * For example, it could be called in Save handler, so that the focus could be placed inside the Modal
 */
export async function unfocusRichEditor() {
  // We need to sleep for 100ms, because when you press e.g. Save button, RichEdit focuses itself.
  // And it focuses immediately AND after 100ms (i.e. they have `setTimeout(()=>focusCore(), 100);` in dx.richedit.js).
  await sleep(120);

  // when we click outside of RichEdit it loses focus
  const mouseEvent = new window.MouseEvent('click', {
    bubbles: true,
    view: window,
  });
  document.dispatchEvent?.(mouseEvent);
}
